import { supabase } from "../../services/SupabaseService";

export interface ProjectStats {
  termCount: number;
  languageCount: number;
  totalCompleted: number;
  totalExpected: number;
  overallPercent: number;
}

export interface ProjectLanguageProgress {
  languageCode: string;
  termCount: number;
  completedCount: number;
  percent: number;
}

class StatsRepository {
  async getProjectStats(projectId: string): Promise<ProjectStats | null> {
    const { data, error } = await supabase
      .from("v_project_stats")
      .select("term_count, language_count, total_completed, total_expected, overall_percent")
      .eq("project_id", projectId)
      .maybeSingle();

    if (error) throw new Error(error.message);
    if (!data) return null;

    return {
      termCount: data.term_count ?? 0,
      languageCount: data.language_count ?? 0,
      totalCompleted: data.total_completed ?? 0,
      totalExpected: data.total_expected ?? 0,
      overallPercent: data.overall_percent ?? 0,
    };
  }

  async getProjectLanguageProgress(projectId: string): Promise<ProjectLanguageProgress[]> {
    const { data, error } = await supabase
      .from("v_project_language_progress")
      .select("language_code, term_count, completed_count, percent")
      .eq("project_id", projectId)
      .order("language_code", { ascending: true });

    if (error) throw new Error(error.message);

    return (data || []).map((row) => ({
      languageCode: row.language_code ?? "",
      termCount: row.term_count ?? 0,
      completedCount: row.completed_count ?? 0,
      percent: row.percent ?? 0,
    }));
  }
}

export default StatsRepository;
